import React, { useEffect } from "react";
import { X, FolderUp } from "lucide-react";
import { EnvioDocumentosUploader } from "./EnvioDocumentosUploader";

export function EnvioDocumentosModal({ processoId, processoNome, userData, onClose, onSuccess }) {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center sm:p-4"
      style={{ backgroundColor: "rgba(15,23,42,0.55)", backdropFilter: "blur(3px)" }}
      onClick={(e) => e.target === e.currentTarget && onClose?.()}
    >
      <div className="w-full sm:max-w-md bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl flex flex-col max-h-[92dvh] overflow-hidden animate-in slide-in-from-bottom-4 sm:zoom-in-95 duration-200">
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100 shrink-0">
          <div className="flex items-center gap-2">
            <FolderUp className="w-4 h-4 text-blue-500 shrink-0" />
            <div>
              <h2 className="text-sm font-bold text-slate-900 leading-tight">Envio de Documentos</h2>
              {processoNome && <p className="text-xs text-slate-500 mt-0.5 leading-tight">{processoNome}</p>}
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors shrink-0"
            aria-label="Fechar"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="overflow-y-auto flex-1 px-5 py-5 overscroll-contain">
          <EnvioDocumentosUploader
            processoId={processoId}
            processoNome={processoNome}
            userData={userData}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        </div>
      </div>
    </div>
  );
}
